require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('./video.styl');

import React from 'react';

class Video extends React.Component {
  render() {

    let videoHeight = this.props.width / 16 * 9;

    return (

      <div
        className='video wrapper'
      >

        <iframe width='100%' frameBorder='0' allowFullScreen='true' height={videoHeight} src='https://www.youtube.com/embed/UUBudztre2o'></iframe>

        <p
          className='graphic legend video padding'
          style={{
            marginBottom: '0px'
          }}
        >
          Andrea Gärtner, Sozialarbeiterin der Caritas Zürich, spricht über Vorurteile gegenüber der Sozialhilfe.
        </p>


      </div>

    );
  }
}

Video.defaultProps = {
};

Video.propTypes = {
  source: React.PropTypes.string,
  width: React.PropTypes.number,
  height: React.PropTypes.number
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/video/Video.component.js